import Cookies, { CookieAttributes } from 'js-cookie';

type Data = { [key: string]: any } | string | number | boolean;

export const getCookie = (name: string) => {
  const value = Cookies.get(name);

  try {
    return value ? JSON.parse(value) : null;
  } catch (e) {
    return value || null;
  }
};
export const setCookie = (name: string, data: Data | Data[], options?: CookieAttributes) => {
  const isString = typeof data === 'string';

  Cookies.set(name, isString ? data : JSON.stringify(data), options);
};
export const removeCookie = (name: string) => Cookies.remove(name);

const prefix = '__dev';
export const SMS_CODE = `${prefix}SMS_CODE`;
export const DEVELOP_INFO = `${prefix}DEVELOP_INFO`;
export const DEVELOP_DISABLE_STEPPER = `${prefix}DEVELOP_DISABLE_STEPPER`;
export const getDevelopmentInfo = () => getCookie(DEVELOP_INFO);
export const setDevelopmentInfo = (val: string) => setCookie(DEVELOP_INFO, val);

export const setStepperDisable = (val: string) => setCookie(DEVELOP_DISABLE_STEPPER, val);
export const getStepperDisable = () => getCookie(DEVELOP_DISABLE_STEPPER);